import React from "react";
import BaseLayout from "./base-layout";
import type { BaseLayoutProps } from "./base-layout";

export default function DefaultLayout({ page, children, ...rest }: BaseLayoutProps): React.JSX.Element {
  return (
    <BaseLayout page={page} {...rest}>
      {children}
    </BaseLayout>
  );
}
